<input
  [name]="props.name"
  [required]="!!props.required"
  [readonly]="props.readonly"
  [formControl]="formControl"
  [formlyAttributes]="field"
  inputDuration
  [isAllowSeconds]="$safeNavigationMigration(field.templateOptions?.isAllowSeconds)"
  [isShowZeroVal]="$safeNavigationMigration(field.templateOptions?.isShowZeroVal)"
  [isValidate]="!!field.templateOptions?.required"
  (change)="onInputValueChange($event)"
  matInput
/>
